import { RefObject } from 'react';

export const runAnimation = (
  animationRef: RefObject<HTMLDivElement>,
  isDarkTheme: boolean = false
) => {
  const amount = 100;

  for (let i = 0; i < amount; i++) {
    createParticle(animationRef, isDarkTheme);
  }
};

const createParticle = (
  animationRef: RefObject<HTMLDivElement>,
  isDarkTheme: boolean
) => {
  const particle = document.createElement('div');
  particle.className = 'particle-animated-point';
  animationRef.current?.appendChild(particle);

  let width = Math.floor(Math.random() * 30 + 8);
  let height = width;
  let destinationX = (Math.random() - 0.5) * 300;
  let destinationY = (Math.random() - 0.5) * 300;
  let rotation = Math.random() * 520;
  let delay = Math.random() * 200;

  // TODO: сделать передачу кастомного цвета
  let color = isDarkTheme
    ? `rgb(80, ${Math.random() * 90 + 75}, 230)`
    : `rgb(255, ${Math.random() * 90 + 120}, 19)`;
  particle.style.boxShadow = `0 0 ${Math.floor(
    Math.random() * 10 + 10
  )}px ${color}`;
  particle.style.background = color;
  particle.style.borderRadius = '50%';
  width = height = Math.random() * 5 + 4;

  particle.style.width = `${width}px`;
  particle.style.height = `${height}px`;

  const animation = particle.animate(
    [
      {
        transform: `translate(0px, 0px) rotate(0deg)`,
        opacity: 1,
      },
      {
        transform: `translate(${destinationX}px, ${destinationY}px) rotate(${rotation}deg)`,
        opacity: 0,
      },
    ],
    {
      duration: Math.random() * 1000 + 5000,
      easing: 'cubic-bezier(0, .9, .57, 1)',
      delay: delay,
    }
  );

  animation.onfinish = () => {
    particle.remove();
  };
};
